import { useState } from "react";
import Button from "../../../../components/UI/Button/Button";
import classes from "../../MngCommon.module.css";
import { useLoaderData, useLocation, useNavigate } from "react-router-dom";
import { ReqCatalogueDelete, ReqCatalogueDetail } from "../../../../api/site/ApiForCatalogue";
import Moment from 'moment';

function MngCatalogueDetail() {

    const catalogue = useLoaderData();

    const location = useLocation();
    const navigate = useNavigate();

    const backHandler = () => {
        navigate("/admin/site/catalog", { state: location.state });
    };
    
    const deleteHandler = async (e) => {
        e.preventDefault();
        
        const isTrue = window.confirm('내용을 삭제하시겠습니까?');
        if(isTrue) {
            try {
                const response = await ReqCatalogueDelete(catalogue.id);
                if (response.status === 200) {
                    alert("내용이 삭제되었습니다.");
                    backHandler();
                } else {
                    alert("내용 삭제 실패");
                }
            } catch (error) {
                console.error("Error:", error);
            }
        } else {
          return
        }
    };

    const updateHandler = () => {
        navigate(`../update/${catalogue.id}`, { state: location.state });
    };

    return (
        <section>
            <div className={classes.admin_contents}>
                <h3>카탈로그 - 상세</h3>
                <div
                    className={`${classes.contents_wrap} ${classes.search_wrap} `}
                >
                    <div className={classes.admin_table_wrap}>
                        <table>
                            <colgroup>
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "40%" }} />
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "40%" }} />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>등록일</th>
                                    <td>{Moment(catalogue.regDate).format('YYYY-MM-DD')}</td>
                                    <th>등록자</th>
                                    <td>{catalogue.regID}</td>
                                </tr>
                                <tr>
                                    <th>노출여부</th>
                                    <td colSpan={3}>{catalogue.exposeYn === "Y" ? "노출" : "미노출"}</td>
                                </tr>
                                <tr>
                                    <th>카탈로그명</th>
                                    <td colSpan={3}>{catalogue.title}</td>
                                </tr>
                                <tr>
                                    <th>첨부파일</th>
                                    <td colSpan={3}>
                                        {catalogue.attachFile != null ? catalogue.attachFile.originalFileName : ""}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className={classes.bottom_btn_wrap}>
                            <Button className="secondary sm" onClick={updateHandler}>수정</Button>
                            <Button className="sm" onClick={deleteHandler}>삭제</Button>
                            <Button className="border sm" onClick={backHandler} >목록</Button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default MngCatalogueDetail;

export const loader = async ({ params }) => {
    const response = await ReqCatalogueDetail(params.catalogId);

    if (response.status === 200) {
        const resData = await response.data;

        return resData;
    } else {
        return [];
    }
};